import React from 'react';

type LoadingSpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
};

const sizeMap: Record<NonNullable<LoadingSpinnerProps['size']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-4',
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  label,
}) => {
  const sizeClasses = sizeMap[size];

  return (
    <div className={`flex items-center justify-center gap-2 ${className}`}>
      <div
        className={`
          animate-spin rounded-full border-t-transparent
          border-gray-300 dark:border-gray-600
          ${sizeClasses}
        `}
      />
      {label && (
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {label}
        </span>
      )}
    </div>
  );
};

export default LoadingSpinner;
